import { InjectionToken } from "@angular/core";
import { SurplusRefundsPort } from "./surplus-refunds.port";

export const SURPLUS_REFUNDS_PORT = new InjectionToken<SurplusRefundsPort>("SURPLUS_REFUNDS_PORT");
